import { styled } from '@mui/material/styles';
import { Icon, IconButton } from 'core/common/ui/ui-kit';

export const ButtonMeuStyled = styled(IconButton)`
  width: 24px;
  min-width: 24px;
  height: 24px;
  padding: 0;
  color: ${({ theme }) => theme.palette.header.menu.color};
`;

export const IconStyled = styled(Icon)`
  width: 24px;
  height: 24px;
  fill: currentColor;
`;
